import styled from '@emotion/styled';
import { nowrapEllipsis, grid } from '../../style-utils';
import { B50, B100, B400, N20, N500, N900 } from '@atlaskit/theme/colors';
export var WIDTH = grid.multiple(22);
export var HALF_WIDTH = WIDTH.half();
var IRREMOVABLE_AVATAR_PADDING_SIZE = 2;

// The +4px is to ensure consistency with the Atlaskit avatar which has a 2px padding around the 24px icon
var ICON_WIDTH = grid.multiple(3).unitless + IRREMOVABLE_AVATAR_PADDING_SIZE * 2;
var ICON_HEIGHT = grid.multiple(3).unitless + IRREMOVABLE_AVATAR_PADDING_SIZE * 2;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var IconWrapper = styled.span({
  height: "".concat(ICON_HEIGHT, "px"),
  width: "".concat(ICON_WIDTH, "px"),
  padding: "0 ".concat(grid.unitless - IRREMOVABLE_AVATAR_PADDING_SIZE, "px 0 ").concat(grid.half().unitless - IRREMOVABLE_AVATAR_PADDING_SIZE, "px")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var LabelWrapper = styled.span({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  // Offset the label's 4px padding-left
  marginLeft: "var(--ds-space-negative-050, -4px)",
  // The -2px is to offset the 28px container (see IconWrapper)
  padding: "".concat(grid.unitless - 2, " 0")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var FilterColLabelText = styled.span(nowrapEllipsis, {
  width: WIDTH.px,
  color: "var(--ds-text, ".concat(N900, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var FilterRowLabelText = styled.span(nowrapEllipsis, {
  paddingLeft: grid.half().px,
  color: "var(--ds-text, ".concat(N900, ")"),
  width: HALF_WIDTH.px
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var CheckboxWrapper = styled.span({
  padding: "".concat(grid.unitless - 2, "px 0"),
  display: 'flex',
  flexGrow: 1
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var PillButton = styled.button(function (props) {
  return {
    height: "".concat(grid.multiple(3).unitless + 2, "px"),
    color: props.selected ? "var(--ds-text-brand, ".concat(B400, ")") : "var(--ds-text-subtlest, ".concat(N500, ")"),
    outline: 'none',
    boxSizing: 'border-box',
    padding: "".concat(grid.half().px, " ").concat(grid.px),
    backgroundColor: props.selected ? "var(--ds-background-selected, ".concat(B50, ")") : "var(--ds-background-accent-gray-subtlest, ".concat(N20, ")"),
    border: 'none',
    borderRadius: '14px',
    lineHeight: "".concat(grid.multiple(2).unitless + 2, "px"),
    cursor: 'pointer',
    display: 'inline-flex',
    ':focus-visible': {
      outline: "2px solid ".concat("var(--ds-border-focused, ".concat(B100, ")")),
      outlineOffset: "var(--ds-space-negative-025, -2px)"
    }
  };
});